import api from './api';

export const attendanceService = {
  // Ping attendance (increment counter)
  async pingAttendance() {
    const response = await api.post('/attendance/ping');
    return response.data;
  },

  // Get current attendance count
  async getAttendanceCount() {
    const response = await api.get('/attendance/count');
    return response.data;
  },

  // Reset attendance count (admin only)
  async resetAttendance() {
    const response = await api.post('/attendance/reset');
    return response.data;
  }
};